import {connect} from 'react-redux';
import DivisionsNew from './DivisionsNew';
import {selectEntityUi} from '../../../redux/actions/divisions';

const mapStateToProps = state => {
  return {
    app_state: state.app_state,
    divisions: state.divisions
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectEntityUi: value => {
      dispatch(selectEntityUi(value));
    }
  };
};

const DivisionsNewContainer = connect(mapStateToProps, mapDispatchToProps)(DivisionsNew);

export default DivisionsNewContainer;
